exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ml-15[data-v-9b73ab7a]{margin-left:15px}.fl-r[data-v-9b73ab7a]{float:right}.mr-20[data-v-9b73ab7a]{margin-right:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-9b73ab7a","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/pharmacy/repertoryWarning/index.vue
// module id = 8/fZ
// module chunks = 47 239